import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dHeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dMaximalCliques from "../Restaumatic.PromotionsEngine.MaximalCliques/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
const newtypeAssignmentVertex = {Coercible0: () => {}};
const mkAssignmentVertex = promotionalItem => productItemKey => ({vertexPromotionalItem: promotionalItem, vertexProductItemKey: productItemKey});
const genericAssignmentVertex = {to: x => x, from: x => x};
const showAssignmentVertex = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
        const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showPromotionalItem(dictShow);
        const $1 = Restaumatic$dPromotionsEngine$dCart$dProductItem.showProductItemKey(dictShow);
        return {
          genericShowArgs: v => [
            (() => {
              const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["vertexProductItemKey", $1.show(v.vertexProductItemKey)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
                "vertexPromotionalItem",
                $0.show(v.vertexPromotionalItem)
              ]))([]));
              if (v$1.length === 0) { return "{}"; }
              return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
            })()
          ]
        };
      })())({reflectSymbol: () => "AssignmentVertex"});
      return x => $0["genericShow'"](x);
    })()
  }
);
const eqAssignmentVertex = dictEq => (
  {
    eq: (() => {
      const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqPromotionalItem(dictEq);
      return x => y => dictEq.eq(x.vertexProductItemKey.product)(y.vertexProductItemKey.product) && x.vertexProductItemKey.productSeq === y.vertexProductItemKey.productSeq && $0.eq(x.vertexPromotionalItem)(y.vertexPromotionalItem);
    })()
  }
);
const canCoallocate = dictEq => keys1 => keys2 => Data$dFoldable.foldrArray(v => v1 => false)(true)(Data$dArray.intersectBy(x => y => dictEq.eq(x.product)(y.product) && x.productSeq === y.productSeq)(keys1)(keys2));
const assignmentVertexToItem = dictOrd => assignmentVertex => Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.setAssignment(dictOrd)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$PromotionalItemAssignment(
  "AssignmentToProduct",
  assignmentVertex.vertexProductItemKey
))(assignmentVertex.vertexPromotionalItem);
const areNonconflicting = dictEq => promotionalItem1 => productItemKey1 => promotionalItem2 => productItemKey2 => canCoallocate(dictEq)(Data$dSemigroup.concatArray([
  productItemKey1
])((() => {
  if (promotionalItem1.source.tag === "NoSource") { return []; }
  if (promotionalItem1.source.tag === "SourceProductItems") { return promotionalItem1.source._1; }
  $runtime.fail();
})()))(Data$dSemigroup.concatArray([productItemKey2])((() => {
  if (promotionalItem2.source.tag === "NoSource") { return []; }
  if (promotionalItem2.source.tag === "SourceProductItems") { return promotionalItem2.source._1; }
  $runtime.fail();
})())) || Restaumatic$dPromotionsEngine$dPromotions$dPromotion.canCombineWith(promotionalItem1.promotion)(promotionalItem2.promotion);
const canCoexist = dictEq => vertex1 => vertex2 => vertex1.vertexPromotionalItem.promotionalItemId !== vertex2.vertexPromotionalItem.promotionalItemId && areNonconflicting(dictEq)(vertex1.vertexPromotionalItem)(vertex1.vertexProductItemKey)(vertex2.vertexPromotionalItem)(vertex2.vertexProductItemKey);
const calcBestProductPromotions = dictEq => assignmentVertices => {
  const $0 = Data$dFoldable.maximumBy(Data$dFoldable.foldableArray)(x => y => Data$dOrd.ordInt.compare(x.length)(y.length))(Restaumatic$dPromotionsEngine$dMaximalCliques.getMaximalCliques(canCoexist(dictEq))(assignmentVertices));
  if ($0.tag === "Nothing") { return []; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
};
const isNonconflicting = dictEq => vertex => userEnabledItem => {
  if (userEnabledItem.assignment.tag === "AssignmentToProduct") {
    return areNonconflicting(dictEq)(vertex.vertexPromotionalItem)(vertex.vertexProductItemKey)(userEnabledItem)(userEnabledItem.assignment._1);
  }
  return true;
};
const productItemAssignmentVertices = dictOrd => userEnabledItems => promotionalItem => productItemKeys => Data$dArray.filter(vertex => Data$dFoldable.foldlArray(Data$dHeytingAlgebra.boolConj)(true)(Data$dFunctor.arrayMap(isNonconflicting(dictOrd.Eq0())(vertex))(userEnabledItems)))(Data$dFunctor.arrayMap(productItemKey => (
  {vertexPromotionalItem: promotionalItem, vertexProductItemKey: productItemKey}
))(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr)(productItemKeys)));
const itemAssignmentVertices = dictOrd => userEnabledItems => promotionalItem => {
  if (promotionalItem.target.tag === "TargetCart") { return []; }
  if (promotionalItem.target.tag === "TargetProductItems") { return productItemAssignmentVertices(dictOrd)(userEnabledItems)(promotionalItem)(promotionalItem.target._1); }
  $runtime.fail();
};
const allAssignmentVerticesForItems = dictOrd => userEnabledItems => Data$dArray.concatMap(itemAssignmentVertices(dictOrd)(userEnabledItems));
const promotionProductAssignment = dictOrd => userEnabledItems => promotionalItems => {
  const assignedItems = Data$dFunctor.arrayMap(assignmentVertexToItem(dictOrd))(calcBestProductPromotions(dictOrd.Eq0())(Control$dBind.arrayBind(promotionalItems)(itemAssignmentVertices(dictOrd)(userEnabledItems))));
  return Data$dSemigroup.concatArray(assignedItems)(Data$dFunctor.arrayMap(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.resetPromotionalItem(dictOrd))(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.excludeItemsFrom(assignedItems)(promotionalItems)));
};
export {
  allAssignmentVerticesForItems,
  areNonconflicting,
  assignmentVertexToItem,
  calcBestProductPromotions,
  canCoallocate,
  canCoexist,
  eqAssignmentVertex,
  genericAssignmentVertex,
  isNonconflicting,
  itemAssignmentVertices,
  mkAssignmentVertex,
  newtypeAssignmentVertex,
  productItemAssignmentVertices,
  promotionProductAssignment,
  showAssignmentVertex
};
